import React, {useState, useCallback } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
import '../../css/ChatGraph.css';
import { convertSingleValue } from '../utils/commonUtils';

export default function ScatterGraph({ data, graph, height=500 }) {
  // マーカーの色を設定
  const stopColor = [
    { start: 'rgba(80, 140, 200, 1)', end: 'rgba(145, 186, 250, 1)' }, // 青
    { start: 'rgba(255, 127, 80, 1)', end: 'rgb(241, 172, 87)' }, // オレンジ
    { start: 'rgba(90, 195, 90, 1)', end: 'rgba(50, 110, 50, 1)' }, // 緑
    { start: 'rgba(147, 112, 219, 1)', end: 'rgba(75, 0, 130, 1)' },  // 紫
    { start: 'rgba(255, 235, 59, 1)', end: 'rgba(251, 192, 45, 1)' }, // 黄色
  ]

    const renderCustomLegend = () => (
      <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', paddingBottom: '20px' }}>
          {data.map((series, index) => (
              <div key={index} className="flex" style={{ color: stopColor[index % stopColor.length].start }}>
                  <div className='mr-2 flex items-center'>
                      <svg width="10" height="10">
                          <circle
                            cx="5" // 円の中心の X 座標
                            cy="5" // 円の中心の Y 座標
                            r="5"  // 半径
                            fill={stopColor[index % stopColor.length].start}
                          />
                      </svg>
                  </div>
                  <div className='flex items-center h-full pt-1 text-gray-600'>{series[0].seriesName}</div>
              </div>
          ))}
      </div>
  );

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      // 系列のインデックスを取得
      const seriesIndex = payload[0].payload.seriesIndex;
      // マーカーの色を取得
      const backgroundColor = stopColor[seriesIndex]['start'];
      return (
        <div className="text-white px-2 py-1 border rounded shadow " style={{ backgroundColor }}>
          <div>{payload[0].payload.dataName} ({payload[0].payload.seriesName})</div>
          <div>{payload[0].payload.xName}: {convertSingleValue(payload[0].value)}{payload[0].payload.xUnit}</div>
          <div>{payload[0].payload.yName}: {convertSingleValue(payload[1].value)}{payload[0].payload.yUnit}</div>
        </div>
      );
    }
    return null;
  };
  
  const formatXTick = (tick) => {
          return convertSingleValue(tick);
      }
  
  const formatYTick = (tick) => {
        return convertSingleValue(tick);
    }

    const CustomMarker = ({ cx, cy, seriesIndex }) => {
    const size = 16;
    const fillColor = stopColor[seriesIndex].end;
    const strokeColor = stopColor[seriesIndex].start;
    return (
      <circle
        cx={cx}
        cy={cy}
        r={size / 2}
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={1}
      />
    );
  };
  
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ScatterChart margin={{ top: 20, right: 30, left: 30, bottom: 40 }}>
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey="x"
          tick={{ fontSize: 12 }}
          tickFormatter={formatXTick} // ラベルを兆や億で表示
          type="number"
        >
          <Label
            value={`${graph.x_name} (${graph.x_unit && graph.x_unit})`}
            position="bottom"
            offset={10}
          />
        </XAxis>

        <YAxis
          dataKey="y"
          tick={{ fontSize: 12,}}
          tickFormatter={formatYTick}
          type="number"
        >
          <Label
            value={`${graph.x_name} (${graph.y_unit && graph.y_unit})`}
            angle={-90}
            position="left"
            offset={15}
            style={{ textAnchor: 'middle', fill: graph.settings.layout.yaxis.color }}
          />
        </YAxis>

        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(200, 200, 200, 0.5)' }} />
        <Legend content={renderCustomLegend} verticalAlign="top" align="left" />

        {/* 系列ごとに Scatter を生成 */}
        {data.map((d, index) => (
          <Scatter
            key={`scatter-${index}`}
            data={d}
            dataKeya={index} // これが seriesIndex として渡される
            fill={stopColor[index].start}
            name={graph.names[index] || `Series ${index + 1}`}
            shape={<CustomMarker seriesIndex={index} />}
          />
        ))}
      </ScatterChart>
    </ResponsiveContainer>
  );
}